const API_URL = 'https://api.ptpa.com:444/api';
export default API_URL;
